module.exports = __webpack_public_path__ + "img/loading.b95073a6.svg";